<template>
    <div id="main-wrapper">

        <NavbarLight/>

        <div class="image-cover hero-banner" :style="{ background: `url(${bg}) no-repeat`, backgroundSize: 'cover' }" >
            <div class="container">
                <h1 class="big-header-capt mb-0" style="color: white;">{{ $t('FromAncientTradeRoutesToModernBusinessHubs') }}</h1>
                <p class="text-center mb-5" style="color: white;">{{ $t('Explore like traders once navigated the Silk Roads') }}</p>
                <FormTwo/>
            </div>
        </div>
        <section>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                            <h2>{{$t('Opportunities don’t knock... Be the first to seize them')}}</h2>
                            <p>{{$t('The latest and most important exhibitions and events in Syria—now at your fingertips')}}</p>
                        </div>
                    </div>
                </div>
                
                <div class="row justify-content-center g-4">
                    <div v-for="(item, index) in exploreExhibit" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                        <div class="card border-0 rounded-4 h-100 position-relative">
                            <router-link v-if="localizedExhibitPath(item)"
                                :to="localizedExhibitPath(item)">
                                <div class="abx-thumb" data-overlay="3">
                                    <img :src="`${item.logo}`" class="img-fluid" alt="exhibit-image">
                                </div>
                            </router-link>

                            <div class="position-absolute top-0 start-0 w-100 p-3">
                                <div class="d-flex justify-content-between align-items-stretch">
                                    <div class="d-flex flex-column text-start">
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.city_name || 'Unknown City' }}</div>
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center mt-1 ">{{ getExhibitStatus(item) }}</div>
                                    </div>
                                    <div class="d-flex flex-column text-end">
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.start_date || 'Unknown start date' }}</div>
                                        <div class="label1 bg-primary text-light px-2 mt-1">{{ item.end_date || 'Unknown end date' }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="position-absolute bottom-0 start-50 translate-middle-x w-100 text-center mb-3">
                                <div class="label1 bg-primary text-light px-2">{{ item.name || 'Unknown exhibit name' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>	
        </section>
        <section class="bg-light">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                               <h2>{{$t('We Track Opportunities — To Bring Them To You')}}</h2>
                            <p>{{$t('We Explore Places, Uncover Potential, And Document Insights To Keep Knowledge Within Your Reach')}}</p>
                        </div>
                    </div>
                </div>
                <GridOne/>
                <div class="row align-items-center justify-content-center">
                    <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
                        <router-link :to="`/${locale}/countries`" class="btn btn-primary px-md-5 rounded">{{ $t('Explore all') }}</router-link>
                    </div>
                </div>
            </div>	
        </section>
        <div class="clearfix"></div>

        <section class="gray-bg">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                            <h2>{{$t('How We Work')}}</h2>
                            <p>{{$t('We maintain constant coordination with companies and event organizers to ensure regularly updated information, facilitate direct communication, and provide accurate and easily accessible contact details')}}</p>
                        </div>
                    </div>
                </div>
                <HowItsWork/>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                            <h2>{{$t('Information is a truly valuable treasure... preserved for everyone')}}</h2>
                            <p>{{$t('The most significant exhibitions and events—whether upcoming or already held—are now at your fingertips')}}</p>
                        </div>
                    </div>
                </div>
                
                <div class="row justify-content-center g-4">
                    <div v-for="(item, index) in endExhibit" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                        <div class="card border-0 rounded-4 h-100 position-relative">
                            <router-link v-if="localizedExhibitPath(item)"
                                :to="localizedExhibitPath(item)">
                                <div class="abx-thumb" data-overlay="3">
                                    <img :src="`${item.logo}`" class="img-fluid" alt="exhibit-image">
                                </div>
                            </router-link>

                            <div class="position-absolute top-0 start-0 w-100 p-3">
                                <div class="d-flex justify-content-between align-items-stretch">
                                    <div class="d-flex flex-column text-start">
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.city_name || 'Unknown City' }}</div>
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center mt-1">{{ getExhibitStatus(item) }}</div>
                                    </div>
                                    <div class="d-flex flex-column text-end">
                                        <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.start_date || 'Unknown start date' }}</div>
                                        <div class="label1 bg-primary text-light px-2 mt-1">{{ item.end_date || 'Unknown end date' }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="position-absolute bottom-0 start-50 translate-middle-x w-100 text-center mb-3">
                                <div class="label1 bg-primary text-light px-2">{{ item.name || 'Unknown exhibit name' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>	
        </section>
        <div class="clearfix"></div>

        <CtaOne/>

        <section>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                            <h2>{{$t('Latest Articles & News')}}</h2>
                            <p>{{$t('Ruqm ... Discover events, expand into markets, and connect with the world')}}</p>
                        </div>
                    </div>
                </div>
                <BlogOne/>
            </div>		
        </section>

        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
import { ref,watch} from "vue";
import axios from "axios";
import bg from '@/assets/img/ruqm.webp';
import BlogOne from '@/components/blog-one.vue';
import CtaOne from '@/components/cta-one.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import FormTwo from '@/components/form/form-two.vue';
import HowItsWork from '@/components/how-its-work.vue';
import NavbarLight from '@/components/navbar/navbar-light.vue';
import GridOne from '@/components/property/grid-one.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';

import { useI18n } from "vue-i18n";

const { t,locale } = useI18n();
const exploreExhibit = ref([]);
const endExhibit = ref([]);
const currentPage = ref(1);
const limit = 8;
const loading = ref(false);

const localizedExhibitPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return null  

  return `/${locale.value}/exhibit/${currentSlug}`
}

const fetchExhibits = async () => {
    loading.value = true;
    try {
        const response = await axios.get(`/exhibits?limit=${limit}&page=${currentPage.value}&lang=${locale.value}`);  
        exploreExhibit.value = response.data.data;
    } catch (error) {
        console.error("Error fetching exhibits:", error);
    } finally {
        loading.value = false;
    }
};
const fetchEndedExhibits = async () => {
    loading.value = true;
    try {
        const response = await axios.get(`/exhibits/ended?limit=${limit}&page=${currentPage.value}&lang=${locale.value}`);  
        endExhibit.value = response.data.data;
    } catch (error) {
        console.error("Error fetching exhibits:", error);
    } finally {
        loading.value = false;
    }
};
watch(locale, fetchExhibits, { immediate: true });
watch(locale, fetchEndedExhibits, { immediate: true });

const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  return new Date(year, month - 1, day);
};

const getExhibitStatus = (item) => {
  if (!item.start_date || !item.end_date) return t('Unknown');

  const now = new Date();

  const start = parseLocalDate(item.start_date);
  start.setHours(0, 0, 0, 0);

  const end = parseLocalDate(item.end_date);
  end.setHours(23, 59, 59, 999); 

  if (now >= start && now <= end) return t('Active');
  if (now < start) return t('Soon');
  if (now > end) return t('Finished');
  return t('Unknown');
};
</script>
